'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const EyeOffIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.93,
        d: "M4.49995 4.5L19.5 19.5M9.89995 9.9C9.29995 10.4 8.99995 11.2 8.99995 12C8.99995 13.7 10.3 15 12 15C12.8 15 13.6 14.7 14.1 14.1M7.09995 7.1C5.29995 8.1 3.79995 9.7 2.89995 11.6C2.79995 11.9 2.79995 12.2 2.89995 12.5C4.59995 15.9 7.99995 18.3 12.1 18.3C13.9 18.3 15.6 17.8 17 17M18.8 15.6C19.8 14.7 20.6 13.6 21.1 12.4C21.2 12.1 21.2 11.8 21.1 11.5C19.5 8.1 16 5.8 12 5.8C11.1 5.8 10.2 5.9 9.39995 6.1",
        stroke: "currentColor"
      }
    )
  }
);
const VpEyeOffIcon = forwardRef(EyeOffIcon);

export { VpEyeOffIcon as default };
